<div class="border-0">
  <header
    class="modal-header d-flex justify-content-between align-items-center"
  >
    <h4 class="text__grey-900 mb-0 f-18 lh-28 fw-600">Account settings</h4>
    <img
      (click)="activeModal.dismiss('Cross click')"
      class="pointer"
      src="/assets/icons/modal-close-icon.svg"
      alt="close"
    />
  </header>
  <div class="col-container">
    <div class="col-35">
      <ul class="nav__list p-0 m-0">
        <li class="nav__list-item">
          <a
            (click)="toggleShowChangePassword()"
            class="nav-link pointer"
            [ngClass]="{ active: !showChangePassword }"
          >
            <span class="f-14 lh-24 fw-400">
              <img
                *ngIf="!showChangePassword"
                src="/assets/icons/edit-profile-active.svg"
                alt=""
              />
              <img
                *ngIf="showChangePassword"
                src="/assets/icons/edit-profile.svg"
                alt=""
              />
              Edit profile
            </span>
          </a>
        </li>
        <li class="nav__list-item">
          <a
            (click)="toggleShowChangePassword()"
            class="nav-link pointer"
            [ngClass]="{ active: showChangePassword }"
          >
            <span class="f-14 lh-24 fw-400">
              <img
                *ngIf="!showChangePassword"
                src="/assets/icons/change-password.svg"
                alt=""
              />
              <img
                *ngIf="showChangePassword"
                src="/assets/icons/change-password-active.svg"
                alt=""
              />
              Change password
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="col-65">
      <div class="row">
        <div class="col-12">
          <div *ngIf="!showChangePassword">
            <app-edit-profile></app-edit-profile>
          </div>
          <div *ngIf="showChangePassword">
            <app-change-password></app-change-password>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
